<script>
import {defineComponent} from 'vue'
import {ElNotification} from "element-plus";


export default defineComponent({
  name: "InitiativeCategoryForm",
  data() {
    return {
      loading: false,
      form: {
        id: null,
        title: null,
      },
      // Switch holatlari (boolean). Submit/load paytida "1"/"0" string'ga o'giriladi.
      isEquipable: false,
      isActive: true,
      rules: {
        title: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
      }
    }
  },
  computed: {
    isEdit() {
      return !!this.form.id;
    }
  },
  methods: {
    getCategoryById() {
      this.loading = true;
      this.$http
          .get(`/api/v1/initiative-categories/${this.form.id}`)
          .then(({data}) => {
            this.form = data;
            // String "1"/"0" -> switch holati ("0" JS'da truthy, shuning uchun === "1")
            this.isEquipable = data.is_equipable === "1";
            this.isActive = data.is_active === "1";
          })
          .catch(({response}) => {
            ElNotification({
              type: "error",
              title: "Xatolik",
              message: response.data.message || "Yuklashda xatolik sodir bo'ldi",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;

          let http;
          if (this.form.id) {
            // Update: tahrirlanadigan maydonlarni yuboramiz (partial/merge)
            const payload = {
              title: this.form.title,
              is_equipable: this.isEquipable ? "1" : "0",
              is_active: this.isActive ? "1" : "0",
            };
            http = this.$http.put(`/api/v1/initiative-categories/${this.form.id}`, payload);
          } else {
            // Create: yangi turkum doim faol boshlaydi
            const payload = {
              title: this.form.title,
              is_equipable: this.isEquipable ? "1" : "0",
              is_active: "1",
            };
            http = this.$http.post("/api/v1/initiative-categories", payload);
          }

          http
              .then(() => {
                // HTTP 200 = muvaffaqiyat (PUT body'da "messgae" typo bor, body'ga ishonmaymiz)
                ElNotification({
                  title: "Tabriklaymiz",
                  message: "Muvafaqiyatli saqlandi",
                  type: "success",
                });
                this.$router.go(-1);
              })
              .catch((error) => {
                const status = error?.response?.status;
                let message;
                if (status === 400) {
                  message = "Ma'lumotlar noto'g'ri. Tekshirib qayta urinib ko'ring";
                } else if (status === 404) {
                  message = "Turkum topilmadi";
                } else if (status === 403) {
                  message = "Sizda ruxsat yo'q";
                } else if (status === 500) {
                  message = "Server xatosi. Keyinroq urinib ko'ring";
                } else {
                  message = error?.response?.data?.message || "Iltimos, qayta urinib ko'ring.";
                }
                ElNotification({
                  title: "Xatolik",
                  message,
                  type: "error",
                });
              })
              .finally(() => {
                this.loading = false;
              });
        }
      })
    }
  },
  mounted() {
    if (this.$route.params.id) {
      this.form.id = this.$route.params.id;
      this.getCategoryById();
    }
  }
})
</script>

<template>
  <div class="main-data" v-loading="loading">
    <el-row>
      <el-col :xs="24" :sm="22" :md="18" :lg="14" :xl="12">
        <el-form ref="form" :model="form" :rules="rules" label-position="top">
          <el-card class="form-card" shadow="never">
            <template #header>
              <span class="card-title">{{ isEdit ? "Turkumni tahrirlash" : "Yangi turkum" }}</span>
            </template>

            <el-form-item label="Nomi" prop="title">
              <el-input
                  type="textarea"
                  :rows="4"
                  v-model="form.title"
                  placeholder="Turkum nomini kiriting"
              />
            </el-form-item>

            <div class="switch-row">
              <div class="switch-row__text">
                <div class="switch-row__label">Jihozlanadiganmi?</div>
                <div class="switch-row__hint">
                  Belgilansa, turkum jihozlanadigan hisoblanadi
                </div>
              </div>
              <div class="switch-row__control">
                <el-switch v-model="isEquipable"/>
                <span class="switch-row__state">{{ isEquipable ? "Ha" : "Yo'q" }}</span>
              </div>
            </div>

            <div v-if="isEdit" class="switch-row">
              <div class="switch-row__text">
                <div class="switch-row__label">Faol holat</div>
                <div class="switch-row__hint">
                  Nofaol turkumlar fuqaroga taklif etilmaydi
                </div>
              </div>
              <div class="switch-row__control">
                <el-switch v-model="isActive"/>
                <span class="switch-row__state">{{ isActive ? "Faol" : "Nofaol" }}</span>
              </div>
            </div>
          </el-card>

          <div class="form-actions">
            <el-button class="custom-btn" @click="() => this.$router.go(-1)">Orqaga</el-button>
            <el-button class="custom-btn" type="primary" :loading="loading" @click="onSubmit">
              Saqlash
            </el-button>
          </div>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<style scoped lang="scss">
.form-card {
  border-radius: 10px;

  .card-title {
    font-family: "Montserrat-Bold", sans-serif;
    font-size: 16px;
    color: #0a194e;
  }
}

.switch-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 0;
  border-top: 1px solid #ebeef5;

  &__label {
    font-weight: 600;
    color: #303133;
  }

  &__hint {
    margin-top: 2px;
    color: #909399;
    font-size: 12px;
  }

  &__control {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
  }

  &__state {
    min-width: 46px;
    font-size: 13px;
    font-weight: 600;
    color: #606266;
  }
}

.form-actions {
  display: flex;
  gap: 10px;
  margin-top: 16px;
}
</style>
